import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import {
  Card, Form, Row, Col, InputGroup, Button, Toast, Alert,
} from 'react-bootstrap';
import { Element, scroller } from 'react-scroll';

import '../ProjectCreate.less';
import '../Page.less';
import '../../components/Form.less';

import CommonInfo from '../../components/project/PassportRead/CommonInfo';
import CommonInfoNew from '../../components/project/PassportRead/CommonInfoNew';
import Contents from '../../components/project/PassportRead/Contents';
import ContentsNew from '../../components/project/PassportRead/ContentsNew';
import ButtonsCard from '../../components/project/PassportRead/ButtonsCard';
import Results from '../../components/project/PassportRead/Results';
import Indicators from '../../components/project/PassportRead/Indicators';
import Budget from '../../components/project/PassportRead/Budget';
import Participants from '../../components/project/PassportRead/Participants';
import ModalSendToHead from '../../components/project/PassportRead/ModalSendToHead';
import ModalRevisionHead from '../../components/project/PassportRead/ModalRevisionHead';
import ModalRevisionExpert from '../../components/project/PassportRead/ModalRevisionExpert';
import ModalUploadScan from '../../components/project/PassportRead/ModalUploadScan';
import ModalCreateNewVersion from '../../components/project/PassportRead/ModalCreateNewVersion';
import ExpertDecisionCard from '../../components/project/PassportRead/ExpertDecisionCard';
import ProjectScrollBox from '../../components/project/Partials/ProjectScrollBox';
import BackBtn from '../../components/UI/BackBtn';

import useAPI from '../../hooks/useAPI';
import useNavProject from '../../hooks/useNavProject';
import useToast from '../../hooks/useToast';
import useUserContext from '../../hooks/useUserContext';

import { status as PS } from '../../helpers/passport';
import { getProjectTypeText } from '../../helpers/typeProject';
import { _default } from './helpers/passport';
import { stepScroll } from '../../helpers';
import { getActionsModel } from './helpers/passportRoleStatus';
import { getActionsModel as getPolicyProjActionsModel } from '../../services/roles/policyProjRoleStatus';
import ConfirmModal from '../../components/common/ConfirmModal';
import { isAdmin, isAdminReadRestricted } from '../../services/rolesSvc';
import {getLastAcceptedProjectVerison} from "../../requests/exportRequests";
import {getFixedPcs} from "../../requests/exportRequests";
import Attachments from '../../components/project/PassportRead/Attachments';
import ModalMoveProject from '../../components/project/PassportRead/ModalMoveProject';
import StatusBadge from '../../components/common/StatusBadge';

export default function PassportRead({
  mngData, stratId, projId, enableEditMode, isLatestVersion,
}) {
  const navProject = useNavProject();
  const api = useAPI();
  const userCtx = useUserContext();
  const addToast = useToast();
  const formEl = useRef(null);
  const history = useHistory();
  const [proj, setProj] = useState(null);
  const [acceptedProj, setAcceptedProj] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [resultsImpact, setResultsImpact] = useState([])
  const [trls, setTrls] = useState([]);
  
  const isNew = new Date(proj?.createdOn).getFullYear() >= 2025;

  const can = useMemo(() => {
    if(proj){
      return (proj.strategy.type === 'policy' || proj.strategy?.useCommitteeApprove)
        ? getPolicyProjActionsModel(proj.status, userCtx, stratId, proj.origins.originProjId, isLatestVersion)
        : getActionsModel(proj.status, userCtx, stratId, proj.origins.originProjId, isLatestVersion)
    }
    return {}
  }, [proj]);
  
  useEffect(async () => {
    await getProj(projId);
  }, []);

  const getProj = async (id) => {
      const getAllInfoAboutProj = async (id, setter, isOldVersion) => {
        const resProj = await api.get(`/projs/${id}?readonly=true`);
        const respProjectStructure = await api.get(`/structure/projs/${id}`);
        if (resProj.error) {
          setError(resProj.error);
          setLoading(false);
          return;
        }
        if (respProjectStructure.error) {
          setError(respProjectStructure.error);
          setLoading(false);
          return;
        }
        const strategyName = respProjectStructure.strategy.name;

        if(!isOldVersion){
          navProject.setProjTitle(respProjectStructure.name);
          if(respProjectStructure.strategy.type === 'policy'){
            navProject.setPolicyTitle(strategyName);
          } else {
            navProject.setStratTitle(strategyName);
          }
        }
        setter({
          ...resProj,
          strategyName,
          startDate: resProj.startDate ? resProj.startDate.substring(0, 10) : undefined,
          endDate: resProj.endDate ? resProj.endDate.substring(0, 10) : undefined,
          approvedOn: resProj.approvedOn ? resProj.approvedOn.substring(0, 10) : undefined,
          attachments: resProj.attachments.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn)) || [],
      });
    }
    await setLoading(true);
    if (id) {
      await getAllInfoAboutProj(id,setProj)
          .then(()=>getLastAcceptedProjectVerison(api,id))
          .then(oldProj => oldProj?.id && getAllInfoAboutProj(oldProj.id, setAcceptedProj, true))
      const respResultsImpact = await api.get(`/strategies/${stratId}/results/0/findByProj?projId=${id}`)
      setResultsImpact(respResultsImpact)
      const trls = await api.get('/mng/trls')
      setTrls(trls)
    } else {
      const resStrat = await api.get('/mng/strategies?short=true');
      const strategyName = proj.strategyId ? resStrat.find((s) => s.id === parseInt(proj.strategyId)).name : '';

      navProject.setProjTitle('Новый проект');
      navProject.setStratTitle(strategyName);

      setProj({
        ...proj,
        strategyName,
      });
    }
    await setLoading(false);
  };

  const updateProjStatus = (status) => setProj((prev) => ({ ...prev, status }));

  const [isModalSendToHeadVisible, setIsModalSendToHeadVisible] = useState(false);
  const [isModalSendToCommittee, setIsModalSendToCommittee] = useState(false);
  const [isModalRevisionExpert, setIsModalRevisionExpert] = useState(false);
  const [isModalRevisionHead, setIsModalRevisionHead] = useState(false);
  const [isModalUpload, setIsModalUpload] = useState(false);
  const [isModalCreateNewVersion, setIsModalCreateNewVersion] = useState(false);
  const [isModalDeleteProj, setIsModalDeleteProj] = useState(false);
  const [isModalMove, setIsModalMove] = useState(false);

  const handleSendHeadSP = async () => {
    await validateProjPlans();
    setIsModalSendToHeadVisible(true);
  };
  const handleReturnForRevisionHead = () => setIsModalRevisionHead(true);
  const handleReturnForRevisionExpert = () => setIsModalRevisionExpert(true);
  const handleApproveFinal = () => setIsModalUpload(true);
  const handleDelete = () => setIsModalDeleteProj(true);
  const handleSendToCommittee = () => setIsModalSendToCommittee(true);

  const apiDelete = async () => {
    const result = await api.del(`/projs/${projId}`, { id: projId });
    setIsModalDeleteProj(false);
    if (result && !result.error) {
      addToast.success('Проект успешно удален');
      history.push(`/strats/${stratId}?t=subprojectconnection`);
    }
  };

  const apiSendHeadSP = async () => {
    const response = await api.post(`/projs/${projId}/sendToHead`);
    if (!response.error && response.status) {
      setProj((prev) => ({ ...prev, ...response }));
      setIsModalSendToHeadVisible(false);
      addToast.success(`Успешно отправлен руководителю ${getProjectTypeText(proj.strategy.type)} на согласование`);
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const apiSendToCommittee = async () => {
    const response = await api.post(`/projs/${projId}/sendToCommittee`);
    if (!response.error && response.status) {
      setProj((prev) => ({ ...prev, ...response }));
      setIsModalSendToCommittee(false);
      addToast.success('Успешно отправлен в Проектный офис');
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const handleSendExperts = async () => {
    if (await validateProjPlans()) {
      const response = await api.post(`/projs/${projId}/sendToExperts`);
      if (!response.error && response.status) {
        setProj((prev) => ({ ...prev, ...response }));
        addToast.success('Успешно отправлен секретарю Экспертной группы');
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      }
    }
  };

  const handleExpertsDecision = async ({ isApproved, recommendations, protocol, mark }) => {
    const response = await api.post(`/projs/${projId}/expertDecision`, { isApproved, recommendations, protocol, mark });
    if (!response.error) {
      setProj((prev) => ({
        ...prev,
        status: response.status,
        expertGroupDecision: response.expertGroupDecision,
        expertGroupProtocol: response.expertGroupProtocol,
        expertGroupMark: response.expertGroupMark,
        commentHead: null,
        commentExpert: null,
      }));
      addToast.success('Решение сохранено');
    }
  };

  const handlePolicyExpertsDecision = async ({ isApproved, recommendations, protocol, mark }) => {
    const response = await api.post(`/projs/${projId}/expertDecision`, { isApproved, recommendations, protocol, mark });
    if (!response.error) {
      setProj((prev) => ({
        ...prev,
        status: response.status,
        expertGroupDecision: response.expertGroupDecision,
        expertGroupProtocol: response.expertGroupProtocol,
        expertGroupMark: response.expertGroupMark,
        commentHead: null,
        commentExpert: null,
        commentCommittee: null,
      }));
      addToast.success('Решение сохранено');
    }
  };

  const apiReturnForRevision = async (comment) => {
    const response = await api.post(`/projs/${projId}/return`, { comment });
    if (!response.error) {
      setProj((prev) => ({ ...prev, ...response }));
      setIsModalRevisionHead(false);
      setIsModalRevisionExpert(false);
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const apiReturnForRevisionHead = apiReturnForRevision;
  const apiReturnForRevisionExpert = apiReturnForRevision;

  const validateProjPlans = async () => {
    const resPlansValid = await api.post('/mng/validate/projPlanExceedsStrategyLimits', {
      projId: proj.id,
      strategyId: proj.strategyId,
      projPlans: proj.plans.filter((p) => p.type === 'fb'),
    });
    if (resPlansValid.error) {
      addToast.error('Не удалось произвести проверку сумм финансирования проекта');
      return false;
    }

    if (resPlansValid.length > 0) {
      const { sources } = mngData.finSources.find((s) => s.type === 'fb');

      const messages = [];
      const plansWithErrors = [...proj.plans];
      resPlansValid.forEach((v) => {
        const pp = plansWithErrors.find((p) => p.id === v.planId);
        if (pp) {
          pp.remainder = v.remainder;
          const agreementNum = sources.agreements.find((a) => a.id === pp.agreementId)?.num;
          const fullCode = sources.bcCodes.find((a) => a.id === pp.bcCodeId)?.fullCode;
          const fundingName = sources.funding.find((a) => a.id === pp.fundingId)?.name;
          messages.push(
            <li key={pp.id}>
              по соглашению {agreementNum ? agreementNum + ' ' : ''}
              по коду "{fullCode ? fullCode + ' ' : ''}"
              {' '}
              {fundingName ? fundingName + ' ' : ''}
            </li>
          );
        }
      });
      addToast.error(<>
        <p style={{ fontWeight: 'bold' }}>Превышен план по {getProjectTypeText(proj.strategy.type)}:</p>
        <ul style={{ paddingLeft: '20px' }}>{messages}</ul>
        <p>
          Обратитесь
          {(proj.status === PS.draft || proj.status === PS.returnedByHeadSP) ? ` к руководителю ${getProjectTypeText(proj.strategy.type)} или` : ''}
          {' '}
          в Проектный офис
        </p>
      </>);
      setProj((prev) => ({ ...prev, plans: plansWithErrors }));
      scroller.scrollTo('Budget', stepScroll);
      return false;
    } return true;
  };

  const handleEdit = (fromCreateNewVersionModal) => {
    if ([PS.approved, PS['-approved'], PS.expertsDeclined, PS.committeeDeclined].includes(proj.status)) {
      if (fromCreateNewVersionModal) {
        enableEditMode(proj, true);
      } else {
        setIsModalCreateNewVersion(true);
      }
    } else {
      enableEditMode(proj);
    }
  };

  const uploadScan = async (file) => {
    const response = await api.postFormData(
      `/projs/${projId}/uploadScan`,
      {},
      file,
        {isJsonValue:false}
    );

    if (response && !response.error) {
      setProj((prev) => ({ ...prev, ...response }));
      addToast.success('Скан успешно загружен');
      return true;
    }
    addToast.error('При загрузке скана произошла ошибка');
    return false;
  };

  const handleMoveProject = async(strategy) => {
    const movedProj = await api.post(`/projs/${proj.id}/move`, {id: proj.id, ...strategy.filterKeys});
    if(movedProj.id){
      if(proj.strategy?.id !== movedProj.strategy.id){
        addToast.success(`Проект успешно перенесен в ${movedProj.strategy.name}`)
      }
      setIsModalMove(false)
      const strategyType = movedProj.strategy.type === 'strategy' ? 'strats' : 'policies'
      if(movedProj.portfId){
        history.push(`/${strategyType}/${movedProj.strategy.id}/portfolios/${movedProj.portfId}/projs/${movedProj.id}`)
        return;
      }
      history.push(`/${strategyType}/${movedProj.strategy.id}/projs/${movedProj.id}`)
    }
  }

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  }
  if (loading) return <section className="page form-page project-card-page"><div className="container">Загрузка...</div></section>;

  return (
    <>
      <section className="page form-page project-card-page">
        <div className="container">
          <div style={{ marginBottom: 16 }}>
            <BackBtn />
          </div>

          <ProjectScrollBox />

          <div style={styledContainer}>
            <h3 style={styledHeading}>Цифровой паспорт</h3>
            <div><StatusBadge type={proj.strategy?.type} status={proj.status}/></div>
          </div>

          {proj.status === 'expertsApproved' && <Alert variant="warning" style={{ whiteSpace: 'pre-wrap' }}>Необходимо разместить подписанный скан Цифрового паспорта. Для размещения используйте кнопку "Действия"</Alert> }
          { proj.commentHead && (
          <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
            <strong>Комментарий руководителя {getProjectTypeText(proj.strategy.type)}</strong>
            <br />
            <br />
            {proj.commentHead}
          </Alert>
          ) }
          { proj.commentExpert && (
          <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
            <strong>Комментарий Проектного офиса</strong>
            <br />
            <br />
            {proj.commentExpert}
          </Alert>
          ) }

          <Form noValidate ref={formEl}>
            <Element id="CommonInfo" name="CommonInfo">
              {isNew ? (
                <CommonInfoNew
                  data={proj}
                  acceptedData={acceptedProj}
                  types={mngData.projTypes}
                  policies={mngData.policies}
                />
              ) : (
                <CommonInfo
                  data={proj}
                  acceptedData={acceptedProj}
                  types={mngData.projTypes}
                  policies={mngData.policies}
                />
              )}
            </Element>
            <Element id="Contents" name="Contents">
              {isNew ? (
                <ContentsNew
                  data={proj}
                  acceptedData={acceptedProj}
                />
              ) : (
                <Contents
                  data={proj}
                  acceptedData={acceptedProj}
                />
              )}
            </Element>
            <Element id="Results" name="Results">
              <Results
                acceptedData={acceptedProj}
                data={proj}
                letters={mngData.letters}
                resultTypes={mngData.resultTypes}
                resultsImpact={resultsImpact}
                trls={trls}
                isNew={isNew}
              />
            </Element>
            <Element id="Indicators" name="Indicators">
              <Indicators data={proj} acceptedData={acceptedProj} />
            </Element>
            <Element id="Budget" name="Budget">
              <Budget dataStatus={proj.status} data={proj.plans} finSources={mngData.finSources} acceptedData={acceptedProj?.plans} isNew={isNew}/>
            </Element>
            <Element id="Participants" name="Participants">
              <Participants dataStatus={proj.status} title="Команда управления" data={proj.users} acceptedData={acceptedProj?.users} userRoles={mngData.userRoles} />
            </Element>
            <Element id="Participants2" name="Participants2">
              <Participants  dataStatus={proj.status} title="Согласующие" data={proj.approvers} userRoles={mngData.userRoles} acceptedData={acceptedProj?.approvers} />
            </Element>
            {proj.attachments.length !== 0 && <Element id="Attachments" name="Attachments">
              <Attachments data={proj}/>
            </Element>}
            {[PS.onApproveExperts, PS.expertsApproved, PS.expertsDeclined, PS.approved, PS.closed, PS.moved].includes(proj.status)
           && isAdminReadRestricted(userCtx)
            && (
            <ExpertDecisionCard
              className="mb-4"
              readOnly={[PS.expertsApproved, PS.expertsDeclined, PS.approved, PS.closed, PS.moved].includes(proj.status)}
              onExpertsDecision={handleExpertsDecision}
              proj={proj}
              canEdit={isAdmin(userCtx)}
            />
            )}
            {(proj.strategy?.type === 'policy' || proj.strategy?.num === 'СЦ10') && [PS.onApproveCommittee, PS.committeeApproved, PS.committeeDeclined, PS.approved, PS.closed, PS.moved].includes(proj.status)
              && (
                <ExpertDecisionCard
                  cardTitle="Решение Цифрового комитета"
                  className="mb-4"
                  readOnly={[PS.committeeApproved, PS.committeeDeclined, PS.approved, PS.closed, PS.moved].includes(proj.status)}
                  canEdit={isAdmin(userCtx)}
                  onExpertsDecision={handlePolicyExpertsDecision}
                  proj={proj}
                />
            )}
            <ButtonsCard
              can={can}
              projId={projId}
              originId={proj.origins ? proj.origins.originProjId : undefined}
              isLatestVersion={isLatestVersion}
              onEdit={handleEdit}
              onEditCurrent={() => enableEditMode(proj)}
              onEditMilestones={() => enableEditMode(proj, false, true)}
              onSendHeadSP={handleSendHeadSP}
              onSendCommittee={handleSendToCommittee}
              onSendExperts={handleSendExperts}
              onReturnForRevisionHead={handleReturnForRevisionHead}
              onReturnForRevisionExpert={handleReturnForRevisionExpert}
              onApproveFinal={handleApproveFinal}
              onDelete={handleDelete}
              onMoveProject={() => setIsModalMove(true)}
              parentProjectType={proj.strategy?.type}
            />
          </Form>
        </div>
      </section>
      <ModalSendToHead
        show={isModalSendToHeadVisible}
        onConfirm={apiSendHeadSP}
        strategyNum={proj?.strategy?.num}
        onClose={() => setIsModalSendToHeadVisible(false)}
      />
      <ModalRevisionHead
        show={isModalRevisionHead}
        onSubmit={apiReturnForRevisionHead}
        onClose={() => setIsModalRevisionHead(false)}
        type={getProjectTypeText(proj.strategy.type)}
      />
      <ModalRevisionExpert
        show={isModalRevisionExpert}
        onSubmit={apiReturnForRevisionExpert}
        onClose={() => setIsModalRevisionExpert(false)}
      />
      <ModalUploadScan
        show={isModalUpload}
        onShow={() => setIsModalUpload(true)}
        onClose={() => setIsModalUpload(false)}
        onSave={uploadScan}
        scanFile={proj.minioScanFile}
        userCtx={userCtx}
      />
      <ModalCreateNewVersion
        show={isModalCreateNewVersion}
        onConfirm={() => { handleEdit(true); setIsModalCreateNewVersion(false); }}
        onClose={() => setIsModalCreateNewVersion(false)}
      />
      <ConfirmModal
        show={isModalDeleteProj}
        onClose={() => setIsModalDeleteProj(false)}
        onConfirm={apiDelete}
        headerText="Удаление проекта"
        message="Проект будет удален, данное действие нельзя отменить. Удалить проект?"
      />
      <ConfirmModal
        show={isModalSendToCommittee}
        onClose={() => setIsModalSendToCommittee(false)}
        onConfirm={apiSendToCommittee}
        headerText="Отправка проекта"
        message="Проект будет направлен в Проектный офис, убедитесь, что поля заполнены верно. Отменить действие будет нельзя"
      />
      <ModalMoveProject
        show={isModalMove}
        onHide={() => setIsModalMove(false)}
        onConfirm={handleMoveProject}
      />
    </>
  );
}

const styledHeading = { marginBottom: 0, textAlign: 'left' };
const styledContainer = { display: 'flex', marginTop: 36, marginBottom: 24, justifyContent: 'space-between' };
